import { render, staticRenderFns } from "./VSubscribeForm.vue?vue&type=template&id=23b46d3a"
import script from "./VSubscribeForm.vue?vue&type=script&lang=js"
export * from "./VSubscribeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports